import { FC, ReactNode } from 'react';
import styles from './Anchor.scss';
import classNames from 'classnames';
import { Pulldown } from 'jbc-front/components/icons';
import { useCurrentAnchor, AnchorLink } from 'jbc-front/components/ScrollSpy/v2';

type AnchorProps = {
  name: string;
  sub?: string[];
  children: ReactNode;
};

export const Anchor: FC<AnchorProps> = ({ name, sub = [], children }) => {
  const current = useCurrentAnchor();
  const isCurrent = current && (current === name || sub.includes(current));

  return (
    <AnchorLink name={name} className={classNames([styles.anchor, { [styles.activeScroll]: isCurrent }])}>
      {children}
      {isCurrent && (
        <div className={styles.arrow}>
          <Pulldown size={10} color="#ccc" />
        </div>
      )}
    </AnchorLink>
  );
};
